<template>
  <div class="container">
    <div class="spinner-container container" v-if="!isFileReady && !isError">
      <div
        class="spinner-grow text-warning text-center"
        style="width: 4rem; height: 4rem"
        role="status"
      ></div>
      <div class="container text-center mt-3 mx-2">
        <span class="lead text-warning">Please Wait! Fetching Results...</span>
      </div>
    </div>
    <div class="container mt-4" v-else-if="isError">
      <Jumbotron
        title="Something Went Wrong..."
        body="Looks like the server could not process your request"
        footer="This error might have arised due to the strict Processing/Memory limit imposed by the hosting platform on which the server is running. Please try again after some time."
      ></Jumbotron>
    </div>
    <div class="container" v-else>
      <Header
        heading="Stylized"
        subHeading="The stylized version of your image is here!"
      />
      <div class="container">
        <div class="image-area mt-5">
          <img
            id="imageResult"
            :src="receivedImage"
            alt=""
            class="img-fluid rounded shadow-lg mx-auto d-block"
          />
        </div>
      </div>
      <div class="container my-4 w-75">
        <div class="row g-2">
          <div class="col">
            <a
              class="btn btn-outline-success btn-lg"
              download="stylized.jpg"
              :href="receivedImage"
              @click="showDownloadToast"
              >Download</a
            >
          </div>
          <div class="col">
            <button
              class="btn btn-outline-info btn-lg"
              @click="$router.push('/')"
            >
              Style Again
            </button>
          </div>
        </div>
      </div>
      <LiveToast
        :title="toastTitle"
        :bodyMessage="toastMessage"
        :toastIconClass="toastIconClass"
        :toastIconColor="toastIconColor"
        ref="liveToast"
      />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import LiveToast from "@/components/LiveToast.vue";
import Jumbotron from "@/components/Jumbotron.vue";

export default {
  name: "ResultView",
  components: {
    Header,
    LiveToast,
    Jumbotron,
  },
  data() {
    return {
      receivedImage: "",
      isFileReceived: false,
      toastTitle: "",
      toastMessage: "",
      toastIconClass: "",
      toastIconColor: "",
      isError: false,
    };
  },
  computed: {
    isFileReady() {
      setTimeout(() => {
        this.showResultToast();
      }, 200);
      return this.isFileReceived;
    },
  },
  mounted() {
    this.$store.dispatch("getResult");
    setTimeout(() => {
      if (this.$store.getters.getReceivedImage !== null) {
        this.isFileReceived = true;
        this.receivedImage = this.$store.getters.getReceivedImage;
        console.log(this.receivedImage);
      } else {
        this.isError = true;
      }
    }, 1500);
  },
  methods: {
    showResultToast() {
      this.toastTitle = "Style Transfer Complete!";
      this.toastMessage = "Your image has been successfully stylized.";
      this.toastIconClass = "fa fa-check-circle";
      this.toastIconColor = "green";
      let toastDiv = this.$refs.liveToast.$refs.liveToastDiv; // Accessing LiveToast Component $refs
      let toast = new bootstrap.Toast(toastDiv);
      toast.show();
    },
    showDownloadToast() {
      this.toastTitle = "Image Downloaded!";
      this.toastMessage = "Your image has been downloaded.";
      this.toastIconClass = "fa fa-arrow-down";
      this.toastIconColor = "steelblue";
      let toastDiv = this.$refs.liveToast.$refs.liveToastDiv; // Accessing LiveToast Component $refs
      let toast = new bootstrap.Toast(toastDiv);
      toast.show();
    },
  },
};
</script>

<style scoped>
.spinner-container {
  margin-top: 10rem;
}

.image-area {
  border: 2px dashed whitesmoke;
  padding: 1rem;
  position: relative;
}

.image-area::before {
  color: #777572;
  font-weight: bold;
  text-transform: uppercase;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 0.8rem;
  z-index: 1;
}

.image-area img {
  z-index: 2;
  position: relative;
}
</style>
